var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"article"},[_c('div',{staticClass:"container faq"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 head"},[_c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('privacy_policy.title')))])])]),_vm._v(" "),_c('div',{staticClass:"row text-justify"},[_c('div',{staticClass:"col-12 pb-5",domProps:{"innerHTML":_vm._s(_vm.$t('privacy_policy.content'))}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-343917d0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/PrivacyPolicy.vue
// module id = 184
// module chunks = 0